import type { ReactNode } from 'react'

import { Pill } from '../ui'

/**
 * One group of journal questions, under a title carrying its time anchor.
 *
 * ── THE ANCHOR IS THE SPRINT ────────────────────────────────────────────────
 *
 * Until schema 2 every question sat under one heading, "How the day felt", and
 * so carried no time at all. "Exercised: Yes" did not say whether the exercise
 * came before this recording; "Sleep hours: 7" did not say which night. The
 * answers were collected faithfully and could not be matched to the measurement
 * beside them even in principle (backlog BSV-011).
 *
 * The anchor is therefore part of the QUESTION and not decoration. It is the
 * same four phrases everywhere a person meets them — this form, the operator
 * app's form, and History's column headers — so an answer is read back under
 * the words it was given under.
 *
 * A `Pill` tone `cyan`, per the concept's §4 component map. `aria-hidden` is
 * deliberately NOT set: a screen-reader user needs "Sleep, last night" as much
 * as a sighted one, and the anchor is inside the heading so it is read with it.
 */
export function JournalGroup({
  title,
  anchor,
  children,
}: {
  title: string
  /** "right now", "last night", "since waking", "last 24 h". */
  anchor?: string
  children: ReactNode
}) {
  return (
    <section className="journal__group">
      <h3 className="journal__group-title">
        {title}
        {anchor !== undefined && (
          <Pill tone="cyan" className="journal__anchor">
            {anchor}
          </Pill>
        )}
      </h3>
      {children}
    </section>
  )
}
